import React from 'react';
import cx from 'classnames';
import './FeatherButton.css';
import { Link } from 'react-router-dom';

export const FeatherButton = ({ to, feather, classNames, ...props }) => {
    return to ? <Link to={to}><button {...props} className={cx(classNames, 'feather-button')}>{feather}</button></Link> :
        <button type="button" {...props} className={cx(classNames, 'feather-button')}>{feather}</button>
};


// WEBPACK FOOTER //
// ./src/components/FeatherButton.js